<template>
  <div class="modal-content fm-modal-text-edit">
    <div class="modal-header">
      <h5 class="modal-title w-75 text-truncate">
        {{ lang.modal.editor.title }}
        <small class="text-muted pl-3">{{ selectedItem.basename }}</small>
      </h5>
      <button type="button" class="close" aria-label="Close" @click="hideModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <v-textarea v-model="code" />
    </div>
    <div class="modal-footer">
      <button class="btn btn-info" @click="updateFile">
        {{ lang.btn.submit }}
      </button>
      <button class="btn btn-light" @click="hideModal">
        {{ lang.btn.cancel }}
      </button>
    </div>
  </div>
</template>

<script>
import modal from "../mixins/modal";
import translate from "../../../mixins/translate";

export default {
  name: "TextEdit",
  mixins: [modal, translate],
  data() {
    return {
      code: ""
    };
  },
  computed: {
    /**
     * Selected disk
     * @returns {*}
     */
    selectedDisk() {
      return this.$store.getters["fm/selectedDisk"];
    },

    /**
     * Selected file
     * @returns {*}
     */
    selectedItem() {
      return this.$store.getters["fm/selectedItems"][0];
    },

    /**
     * Calculate the height of the code editor
     * @returns {number}
     */
    editorHeight() {
      if (this.$store.state.fm.modal.modalBlockHeight) {
        return this.$store.state.fm.modal.modalBlockHeight - 200;
      }

      return 300;
    }
  },
  mounted() {
    // get file for edit
    this.$store
      .dispatch("fm/getFile", {
        disk: this.selectedDisk,
        path: this.selectedItem.path
      })
      .then(response => {
        // add code
        if (this.selectedItem.extension === "json") {
          this.code = JSON.stringify(response.data, null, 4);
        } else {
          this.code = response.data;
        }
      });
  },
  methods: {
    // Update file
    updateFile() {
      const formData = new FormData();
      // add disk name
      formData.append("disk", this.selectedDisk);
      // add path
      formData.append("path", this.selectedItem.dirname);
      // add updated file
      formData.append(
        "file",
        new Blob([this.code]),
        this.selectedItem.basename
      );

      this.$store.dispatch("fm/updateFile", formData).then(response => {
        // if file updated successfully
        if (response.data.result.status === "success") {
          // close modal window
          this.hideModal();
        }
      });
    }
  }
};
</script>

<style lang="scss">
.fm-modal-text-edit {
  .modal-body {
    padding: 0;
  }
}
</style>
